import { CSP_NONCE } from './cspNonce';

// react-hot-toast styles itself via goober, which injects a <style id="_goober">
// into <head> at runtime with no nonce -- so our nonce-based CSP (style-src has no
// 'unsafe-inline') rejects it and toast styles never apply. Goober checks
// window._goober before creating its own element, so we pre-seed a nonced <style>
// and point window._goober at it. Goober then reuses our element, which carries the
// matching nonce, so CSP allows every rule it appends. Mirrors the Emotion nonce
// setup in index.js.
//
// This MUST run before goober loads. react-hot-toast defines its animations with
// goober at module-eval time, and ES-module imports are hoisted -- so this file has
// to be the FIRST import in index.js and seed on import (a call from index.js's body
// would run too late, after goober already created an un-nonced sheet).
function seedGooberNonce(nonce) {
	if (typeof document === 'undefined' || typeof window === 'undefined') return;
	if (window._goober) return;

	let el = document.getElementById('_goober');
	if (!el) {
		el = document.createElement('style');
		el.id = '_goober';
		if (nonce) {
			el.setAttribute('nonce', nonce);
			// Property form is the reliable one for JS-created elements.
			el.nonce = nonce;
		}
		// goober reads .firstChild.data, so the text node must already exist.
		el.appendChild(document.createTextNode(' '));
		document.head.appendChild(el);
	}
	window._goober = el;
}

seedGooberNonce(CSP_NONCE);
